import i18n from '@/helpers/i18n'
import { DEFAULT_DATE_FORMAT, DEFAULT_DATETIME_FORMAT, FORMAT_MONTH_YEAR, SHORT_DATE_FORMAT } from '@/consts/formats'

export default {
  install(Vue, options) {
    Vue.prototype.$format = {
      shortDate: datetime => {
        return i18n.dayjs(datetime).format(SHORT_DATE_FORMAT)
      },
      shortMonthDay: datetime => {
        return i18n.dayjs(datetime).format(i18n.t('format-shortMonthDay'))
      },
      date: (datetime, format) => {
        if (!format) {
          format = DEFAULT_DATE_FORMAT
        }
        return i18n.dayjs(datetime).format(format)
      },
      dateTime: (datetime, format) => {
        if (!format) {
          format = DEFAULT_DATETIME_FORMAT
        }
        return i18n.dayjs(datetime).format(format)
      },
      dateMonthYear: datetime => {
        return i18n.dayjs(datetime).format(FORMAT_MONTH_YEAR)
      },
      dateDiff: (startDate, endDate, format) => {
        if (!format) {
          format = DEFAULT_DATE_FORMAT
        }
        return i18n.dayjs(endDate).diff(i18n.dayjs(startDate), format)
      },
      nl2br(text) {
        if (!text) return text

        return Vue.prototype.$format.escapeHtml(text).replace(/\n/g, '<br/>')
      },
      escapeHtml(html) {
        // https://stackoverflow.com/a/30930653
        return document.createElement('div').appendChild(document.createTextNode(html)).parentNode.innerHTML
      },
      stripHtml(html) {
        const el = document.createElement('div')
        el.innerHTML = html
        return el.innerText.trim()
      }
    }
  }
}
